import { ObjectOf } from 'ck-core/source/types/ObjectOf';

export function trackAnalytic(event: string, data?: ObjectOf<any>) {
	CK.trackAnalytic(event, data);
}
